import * as React from "react"
import {
  BooleanField,
  CreateButton,
  DatagridConfigurable,
  DateField,
  List,
  SearchInput,
  TopToolbar,
  TextField,
  EmailField,
  useListContext,
  BulkDeleteButton, 
  DeleteWithConfirmButton,
  useGetIdentity,
  useRecordContext
} from "react-admin"
import { useMediaQuery, Button, Box } from "@mui/material"
import ContentFilter from '@mui/icons-material/FilterList';
import UserFilterForm from "./UserFilterForm"

const UserFilterButton = () => {
  const { showFilter } = useListContext();
  return (
    <Button
        size="small"
        color="primary"
        onClick={() => showFilter("main")}
        startIcon={<ContentFilter />}
        sx={{
          height: '27.5px', // 調整按鈕高度
          padding: '4px 5px', // 調整內邊距
          fontSize: '13px', // 調整字型大小，這樣可以與 CreateButton 大小對齊
        }}
    >
      篩選
    </Button>
  );
};

const mobileFilters = [
  <SearchInput source="q" alwaysOn />
]

const UserListActions = () => (
  <Box width="100%">
    <TopToolbar>
      <UserFilterButton />
      <CreateButton />
    </TopToolbar>
    <UserFilterForm />
  </Box>
)

const UserBulkActionButtons = () => (
  <>
    <BulkDeleteButton 
      confirmTitle="確認刪除"
      confirmContent="您確定要刪除這些帳號嗎？"
      mutationMode="optimistic"
    />
  </>
);

const UserTitle = () => {
  return <span>{'帳號'}</span>;
};

const UserList = () => {
  const { identity } = useGetIdentity();
  const isXsmall = useMediaQuery(theme => theme.breakpoints.down("sm"))
  const isSmall = useMediaQuery(theme => theme.breakpoints.down("md"))

  const CustomDeleteButton = () => {
    const record = useRecordContext();
    const isCurrentUser = record?.id === identity?.id;
    
    return (
      <DeleteWithConfirmButton
        disabled={isCurrentUser}
        confirmTitle="確認刪除"
        confirmContent="您確定要刪除此帳號嗎？"
      />
    );
  };

  return (
    <List
      title={<UserTitle/>}
      filters={isSmall ? mobileFilters : undefined}
      sort={{ field: "createdAt", order: "ASC" }}
      perPage={25}
      actions={<UserListActions />}
    >
      {isXsmall ? (
        <div></div>
      ) : (
        <DatagridConfigurable
          rowClick="edit"
          bulkActionButtons={<UserBulkActionButtons />}
          sx={{
            "& .column-groups": {
              md: { display: "none" },
              lg: { display: "table-cell" }
            }
          }}
          omit={["id"]}
          isRowSelectable={ record => record?.id !== identity?.id }
        >
          <TextField
            source="id"
            label="ID"
          />
          <TextField
            source="name"
            label="名稱"
          />
          <EmailField
            source="account"
            label="帳號"
          />
          <EmailField
            source="email"
            label="Email"
          />
          <BooleanField
            source="status"
            label="啟用狀態"
          />
          <DateField 
            source="createdAt" 
            label="建立時間"  
            showTime
          />
          <CustomDeleteButton />
        </DatagridConfigurable>
      )}
    </List>
  )
}

export default UserList